export default __webpack_public_path__ + "static/media/Accueil_Connecté.86cdd85a.png";